/* IvitaPure — Crealyte PDP: Vad forskningen säger.
   Ett referensnummer (#ref-N) eller en länk till #referenser öppnar den fällbara
   listan och scrollar till rätt rad. Mjuk scroll bara om användaren inte bett om
   mindre rörelse. Idempotent: klicklyssnaren ligger på dokumentet och binds en gång,
   så den gäller även sektioner som laddas om i temaredigeraren.

   Referenskort: har numret data (script[data-cpdp-refdata] med fråga eller
   sammanfattning) öppnar klick på bubblan ett kort vid bubblan i stället för att
   scrolla. Ett enda kort i body återanvänds. Allt innehåll sätts med textContent.
   Direktlänkar med #ref-N öppnar aldrig kortet, bara listan som förut. */
(function () {
  if (window.__cpdpResearch) return;
  window.__cpdpResearch = true;

  var HASH = /^#(ref-\d+|referenser)$/;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function flash(el) {
    el.classList.add('is-target');
    clearTimeout(el.__cpdpFlash);
    el.__cpdpFlash = setTimeout(function () { el.classList.remove('is-target'); }, 1400);
  }

  /* Öppnar listan och visar målet. Returnerar false om målet inte ligger i en
     referenslista i en forskningssektion, så att vanlig ankarlänk får gälla. */
  function showRef(id, instant) {
    var el = document.getElementById(id);
    if (!el) return false;
    var det = el.matches('details[data-cpdp-refs]') ? el : el.closest('details[data-cpdp-refs]');
    if (!det) return false;
    if (!det.open) det.open = true;
    var isList = el === det;

    /* scrollIntoView räknar om layouten själv, så den nyss öppnade listan har sin höjd */
    try {
      el.scrollIntoView({ behavior: (instant || reducedMotion()) ? 'instant' : 'smooth', block: isList ? 'start' : 'center' });
    } catch (e) {
      el.scrollIntoView(true);
    }
    if (!isList) {
      flash(el);
      try { el.focus({ preventScroll: true }); } catch (e) { /* äldre webbläsare */ }
    }
    return true;
  }

  /* Länkarna till studierna (DOI/PubMed) öppnas i en ny flik, så besökaren inte
     tappar sidan. Textfältet i temaredigeraren kan inte sätta target själv. */
  function externalRefLinks(root) {
    (root || document).querySelectorAll('.cpdp-rs-reflist a[href^="http"]').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }

  /* =====================================================================
     Referenskort
     ===================================================================== */

  var POP_ID = 'cpdp-refpop';
  var Q_ID = 'cpdp-refpop-q';
  var BUBBLE = 'sup.ref a[href^="#ref-"]';
  var GAP = 8;      /* luft mellan bubbla och kort */
  var EDGE = 12;    /* minsta avstånd till fönsterkanten */
  var SVGNS = 'http://www.w3.org/2000/svg';

  var dataCache = null;
  /* Referenskortets länktexter: sätts från sektionens inställningar i readData(). */
  var labels = null;
  var LABELS_DEFAULT = { open: 'Öppna studien', fulltext: 'Fri fulltext', list: 'Visa i referenslistan' };
  var pop = null;
  var popBody = null;
  var popFoot = null;
  var openBubble = null;

  /* Toning ovanför foten när det finns mer text att scrolla fram i kortet */
  function updateMore() {
    if (!pop || !popBody) return;
    var more = popBody.scrollHeight - popBody.clientHeight - popBody.scrollTop > 4;
    pop.classList.toggle('has-more', more);
  }

  function str(v) {
    if (v == null) return '';
    return String(v).trim();
  }

  /* Samlar datan från alla data-block på sidan. Första förekomsten av ett nummer
     gäller, samma som getElementById väljer första li#ref-N. */
  function readData() {
    if (dataCache) return dataCache;
    dataCache = {};
    document.querySelectorAll('script[data-cpdp-refdata]').forEach(function (s) {
      /* Kortets länktexter kommer från forskningssektionens inställningar (data-*-label
         på samma script-tagg). Första taggen med texter gäller; saknas de används
         de svenska standardtexterna nedan. */
      if (!labels && s.getAttribute('data-open-label')) {
        labels = {
          open: s.getAttribute('data-open-label') || LABELS_DEFAULT.open,
          fulltext: s.getAttribute('data-fulltext-label') || LABELS_DEFAULT.fulltext,
          list: s.getAttribute('data-list-label') || LABELS_DEFAULT.list
        };
      }
      var arr;
      try { arr = JSON.parse(s.textContent); } catch (e) { return; }
      if (!Array.isArray(arr)) return;
      arr.forEach(function (o) {
        if (!o || typeof o !== 'object') return;
        var n = parseInt(o.n, 10);
        if (!(n > 0) || Object.prototype.hasOwnProperty.call(dataCache, n)) return;
        dataCache[n] = o;
      });
    });
    return dataCache;
  }

  function refNum(a) {
    var m = /^#ref-(\d+)$/.exec(a.getAttribute('href') || '');
    return m ? parseInt(m[1], 10) : 0;
  }

  /* Data för en bubbla, eller null om kortet inte ska öppnas (ingen fråga och
     ingen sammanfattning). */
  function dataFor(a) {
    var n = refNum(a);
    if (!n) return null;
    var d = readData()[n];
    if (!d || (!str(d.question) && !str(d.summary))) return null;
    return d;
  }

  function isBubble(el) {
    return !!(el && el.closest && el.closest(BUBBLE));
  }

  /* aria-haspopup och aria-expanded på bubblor som har ett kort; bort från dem som
     inte har det (t.ex. när datan tömts i temaredigeraren). */
  function decorate() {
    document.querySelectorAll(BUBBLE).forEach(function (a) {
      if (dataFor(a)) {
        a.setAttribute('aria-haspopup', 'dialog');
        a.setAttribute('aria-expanded', a === openBubble ? 'true' : 'false');
      } else if (a !== openBubble) {
        a.removeAttribute('aria-haspopup');
        a.removeAttribute('aria-expanded');
        a.removeAttribute('aria-controls');
      }
    });
  }

  function setExpanded(a, on) {
    if (!a) return;
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) a.setAttribute('aria-controls', POP_ID);
    else a.removeAttribute('aria-controls');
  }

  /* ---------- DOM-hjälp: bara textContent och attribut ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* Enkla streckikoner i currentColor. Formerna är fasta, aldrig data. */
  var ICONS = {
    close: [['path', { d: 'M6 6l12 12M18 6L6 18' }]],
    dose: [
      ['path', { d: 'M9 3h6' }],
      ['path', { d: 'M10 3v6.2l-5.4 9.2A1.7 1.7 0 0 0 6.1 21h11.8a1.7 1.7 0 0 0 1.5-2.6L14 9.2V3' }],
      ['path', { d: 'M7.1 15h9.8' }]
    ],
    people: [
      ['circle', { cx: '12', cy: '8', r: '3.6' }],
      ['path', { d: 'M4.8 20.5c.8-3.9 3.7-6.2 7.2-6.2s6.4 2.3 7.2 6.2' }]
    ],
    time: [
      ['circle', { cx: '12', cy: '12', r: '8.5' }],
      ['path', { d: 'M12 7.5V12l3 2' }]
    ],
    out: [['path', { d: 'M8 16L16 8M9.5 8H16v6.5' }]]
  };

  function icon(name, cls) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', '16');
    s.setAttribute('height', '16');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.6');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    if (cls) s.setAttribute('class', cls);
    ICONS[name].forEach(function (p) {
      var node = document.createElementNS(SVGNS, p[0]);
      Object.keys(p[1]).forEach(function (k) { node.setAttribute(k, p[1][k]); });
      s.appendChild(node);
    });
    return s;
  }

  /* http(s) eller en relativ sökväg på sajten. Allt annat (javascript: m.m.) ignoreras. */
  function safeUrl(u) {
    u = str(u);
    return /^https?:\/\//i.test(u) || /^\/(?![\/\\])/.test(u) ? u : '';
  }

  function ensurePop() {
    if (pop && document.body.contains(pop)) return pop;
    pop = document.getElementById(POP_ID);
    if (!pop) {
      pop = el('div', 'ip cpdp cpdp-refpop');
      pop.id = POP_ID;
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-modal', 'false');
      pop.setAttribute('aria-labelledby', Q_ID);
      pop.hidden = true;

      var x = el('button', 'cpdp-refpop-x');
      x.type = 'button';
      x.setAttribute('aria-label', 'Stäng');
      x.appendChild(icon('close'));
      pop.appendChild(x);

      popBody = el('div', 'cpdp-refpop-body');
      pop.appendChild(popBody);
      /* Länkarna ligger i en egen fot under den scrollande delen, så de alltid syns
         även när sammanfattningen är lång (på mobil scrollade de annars ut ur kortet). */
      popFoot = el('div', 'cpdp-refpop-foot');
      pop.appendChild(popFoot);
      document.body.appendChild(pop);
    }
    popBody = pop.querySelector('.cpdp-refpop-body');
    popFoot = pop.querySelector('.cpdp-refpop-foot');

    if (!pop.__cpdpBound) {
      pop.__cpdpBound = true;
      popBody.addEventListener('scroll', updateMore, { passive: true });
      pop.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.cpdp-refpop-x')) {
          e.preventDefault();
          close('bubble');
        } else if (t.closest('.cpdp-refpop-tolist')) {
          /* Kortet stängs här; dokumentets klicklyssnare kör sedan showRef för länken */
          close(false);
        }
      });
      pop.addEventListener('keydown', onPopKeydown);
    }
    return pop;
  }

  function fill(d, n) {
    while (popBody.firstChild) popBody.removeChild(popBody.firstChild);
    while (popFoot.firstChild) popFoot.removeChild(popFoot.firstChild);

    var q = str(d.question);
    var sum = str(d.summary);

    /* rubrik: rund siffra + fråga */
    var head = el('div', 'cpdp-refpop-head');
    head.appendChild(el('span', 'cpdp-refpop-n', String(n))).setAttribute('aria-hidden', 'true');
    var h = el('div', 'cpdp-refpop-q');
    h.id = Q_ID;
    h.setAttribute('role', 'heading');
    h.setAttribute('aria-level', '3');
    h.tabIndex = -1;
    h.appendChild(el('span', 'cpdp-refpop-sr', 'Referens ' + n + (q ? ': ' : '')));
    if (q) h.appendChild(document.createTextNode(q));
    head.appendChild(h);
    popBody.appendChild(head);

    if (sum) {
      var p = el('p', 'cpdp-refpop-sum', sum);
      p.id = POP_ID + '-sum';
      popBody.appendChild(p);
      pop.setAttribute('aria-describedby', p.id);
    } else {
      pop.removeAttribute('aria-describedby');
    }

    var type = str(d.study_type);
    if (type) {
      var pr = el('p', 'cpdp-refpop-type');
      pr.appendChild(el('span', 'cpdp-refpop-pill', type));
      popBody.appendChild(pr);
    }

    /* dos, deltagare, längd: ett tomt fält döljs */
    var facts = [
      ['dose', 'Dos: ', str(d.dose)],
      ['people', 'Deltagare: ', str(d.population)],
      ['time', 'Längd: ', str(d.duration)]
    ].filter(function (f) { return f[2]; });
    if (facts.length) {
      var ul = el('ul', 'cpdp-refpop-facts');
      ul.setAttribute('role', 'list');
      facts.forEach(function (f) {
        var li = el('li', 'cpdp-refpop-fact');
        li.appendChild(icon(f[0]));
        var t = el('span', 'cpdp-refpop-fact-txt');
        t.appendChild(el('span', 'cpdp-refpop-sr', f[1]));
        t.appendChild(document.createTextNode(f[2]));
        li.appendChild(t);
        ul.appendChild(li);
      });
      popBody.appendChild(ul);
    }

    /* år · författare · tidskrift */
    var meta = [
      ['cpdp-refpop-year', str(d.year), 'span'],
      ['cpdp-refpop-auth', str(d.authors), 'span'],
      ['cpdp-refpop-jour', str(d.journal), 'i']
    ].filter(function (m) { return m[1]; });
    if (meta.length) {
      var mp = el('p', 'cpdp-refpop-meta');
      meta.forEach(function (m, i) {
        if (i) mp.appendChild(el('span', 'cpdp-refpop-dot', ' · ')).setAttribute('aria-hidden', 'true');
        mp.appendChild(el(m[2], m[0], m[1]));
      });
      popBody.appendChild(mp);
    }

    /* länkar */
    var links = el('p', 'cpdp-refpop-links');
    var L = labels || LABELS_DEFAULT;
    [[safeUrl(d.doi_url), L.open], [safeUrl(d.fulltext_url), L.fulltext]].forEach(function (l) {
      if (!l[0]) return;
      var a = el('a', 'cpdp-refpop-link');
      a.href = l[0];
      a.target = '_blank';
      a.rel = 'noopener';
      a.appendChild(document.createTextNode(l[1]));
      a.appendChild(el('span', 'cpdp-refpop-sr', ' (öppnas i ny flik)'));
      a.appendChild(icon('out', 'cpdp-refpop-out'));
      links.appendChild(a);
    });
    if (document.getElementById('ref-' + n)) {
      var toList = el('a', 'cpdp-refpop-link cpdp-refpop-tolist', L.list);
      toList.href = '#ref-' + n;
      links.appendChild(toList);
    }
    if (links.firstChild) popFoot.appendChild(links);
    popFoot.hidden = !links.firstChild;

    popBody.scrollTop = 0;
  }

  /* Fri yta i fönstret: under den fasta headern och ovanför den fasta köpraden */
  function bounds(vh) {
    var top = EDGE;
    var bottom = vh - EDGE;
    /* Sidhuvudet: överst i fönstret räknas det även när USP-raden ligger ovanför
       (då börjar headern på 45 px, inte 0), annars hamnade kortet under menyn. */
    var hdr = document.querySelector('.site-header');
    if (hdr) {
      var hr = hdr.getBoundingClientRect();
      if (hr.top < vh / 4 && hr.bottom > 0 && hr.bottom < vh / 2) top = Math.max(top, hr.bottom + EDGE);
    }
    var bar = document.querySelector('.cpdp-sticky-bar.is-shown');
    if (bar) {
      var br = bar.getBoundingClientRect();
      if (br.height && br.top > vh / 2 && br.top < vh) bottom = Math.min(bottom, br.top - EDGE);
    }
    return { top: top, bottom: bottom };
  }

  function place() {
    if (!openBubble || !pop || pop.hidden) return;
    if (!document.contains(openBubble) || !openBubble.getClientRects().length) {
      close(false);
      return;
    }
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh = window.innerHeight;
    var r = openBubble.getBoundingClientRect();
    var b = bounds(vh);

    pop.style.width = Math.max(0, Math.min(440, vw - EDGE * 2)) + 'px';
    pop.style.maxHeight = '';
    var w = pop.offsetWidth;
    var h = pop.offsetHeight;   /* offsetHeight påverkas inte av infadens scale */

    var below = b.bottom - r.bottom - GAP;
    var above = r.top - GAP - b.top;
    var side;
    if (h <= below) {
      side = 'below';
    } else if (h <= above) {
      side = 'above';
    } else {
      /* ryms inte helt åt något håll: den större sidan, med intern scroll */
      side = below >= above ? 'below' : 'above';
      var room = Math.max(side === 'below' ? below : above, 220);
      if (room < h) {
        pop.style.maxHeight = Math.floor(room) + 'px';
        h = pop.offsetHeight;
      }
    }

    var cx = r.left + r.width / 2;
    var left = Math.max(EDGE, Math.min(cx - w / 2, vw - EDGE - w));
    var top = side === 'below' ? r.bottom + GAP : r.top - GAP - h;

    /* fönsterkoordinater till dokumentet, rättat för ett ev. positionerat body */
    pop.style.left = '0px';
    pop.style.top = '0px';
    var ox = pop.offsetLeft;
    var oy = pop.offsetTop;
    pop.style.left = Math.round(left + window.pageXOffset - ox) + 'px';
    pop.style.top = Math.round(top + window.pageYOffset - oy) + 'px';
    pop.style.transformOrigin = Math.round(Math.max(0, Math.min(w, cx - left))) + 'px ' + (side === 'below' ? '0' : '100%');
    pop.setAttribute('data-side', side);
    updateMore();
  }

  function open(a, d) {
    ensurePop();
    var n = refNum(a);
    if (openBubble && openBubble !== a) setExpanded(openBubble, false);
    openBubble = a;
    setExpanded(a, true);
    fill(d, n);

    pop.classList.remove('is-open');
    pop.hidden = false;
    place();
    void pop.offsetWidth;   /* startläget ritas innan infaden */
    pop.classList.add('is-open');

    var h = document.getElementById(Q_ID);
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
  }

  /* focusTo: 'bubble' flyttar fokus tillbaka till bubblan, false låter fokus vara */
  function close(focusTo) {
    if (!openBubble) return;
    var b = openBubble;
    openBubble = null;
    setExpanded(b, false);
    if (pop) {
      pop.classList.remove('is-open');
      pop.hidden = true;
    }
    if (focusTo === 'bubble' && document.contains(b)) {
      try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); }
    }
  }

  /* ---------- Tangentbord ---------- */
  var TABBABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [tabindex], [contenteditable="true"]';

  function visible(e) {
    if (!e.getClientRects().length) return false;
    var cs = window.getComputedStyle(e);
    return cs.visibility !== 'hidden';
  }

  /* Nästa element i tabbordningen efter bubblan, utan kortet */
  function nextAfter(b) {
    var list = Array.prototype.filter.call(document.querySelectorAll(TABBABLE), function (e) {
      if (pop && pop.contains(e)) return false;
      if (e.tabIndex < 0) return false;
      return visible(e);
    });
    var i = list.indexOf(b);
    return i >= 0 ? list[i + 1] || null : null;
  }

  /* Kortet är inte modalt: Tab förbi sista länken stänger det och går vidare på
     sidan efter bubblan, Skift+Tab förbi första går tillbaka till bubblan. */
  function onPopKeydown(e) {
    if (e.key !== 'Tab' || !openBubble) return;
    var items = Array.prototype.filter.call(pop.querySelectorAll(TABBABLE), visible);
    var i = items.indexOf(document.activeElement);
    if (e.shiftKey ? i <= 0 : i === items.length - 1) {
      e.preventDefault();
      if (e.shiftKey) {
        close('bubble');
      } else {
        var next = nextAfter(openBubble);
        var b = openBubble;
        close(next ? false : 'bubble');
        if (next) {
          try { next.focus(); } catch (err) { b.focus(); }
        }
      }
    }
  }

  document.addEventListener('keydown', function (e) {
    if (!openBubble) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      close('bubble');
    }
  });

  /* ---------- Klick utanför ----------
     Pekar-händelser i stället för click: iOS skickar inget click till dokumentet
     vid tryck på ytor utan egen klickhantering. Ett tryck som blir en scroll
     (pointercancel eller rörelse) stänger inte kortet. */
  var down = null;
  document.addEventListener('pointerdown', function (e) {
    down = openBubble ? { x: e.clientX, y: e.clientY, t: e.target } : null;
  }, true);
  document.addEventListener('pointercancel', function () { down = null; }, true);
  document.addEventListener('pointerup', function (e) {
    var d = down;
    down = null;
    if (!d || !openBubble || !pop) return;
    if (Math.abs(e.clientX - d.x) > 10 || Math.abs(e.clientY - d.y) > 10) return;
    var t = d.t;
    if (!t || !t.closest) return;
    if (pop.contains(t)) return;
    /* bubblor med kort sköts av klicklyssnaren: samma stänger, en annan byter */
    if (isBubble(t) && dataFor(t.closest(BUBBLE))) return;
    var ae = document.activeElement;
    close(!ae || ae === document.body || pop.contains(ae) ? 'bubble' : false);
  }, true);

  /* ---------- Klick på nummer och ankarlänkar ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var hash = a.getAttribute('href');
    if (!HASH.test(hash)) return;

    /* Referensbubbla med kortdata: kortet i stället för listan */
    if (a.matches(BUBBLE)) {
      var d = dataFor(a);
      if (d) {
        e.preventDefault();
        if (openBubble === a) close('bubble');
        else open(a, d);
        return;
      }
    }

    if (!showRef(hash.slice(1))) return;
    e.preventDefault();
    if (window.location.hash !== hash && window.history && history.pushState) {
      history.pushState(null, '', hash);
    }
  });

  /* Ny placering när fönstrets bredd ändras (resize kommer redan en gång per
     bildruta). Bara höjden (mobilens adressfält som döljs vid scroll) räknas inte
     om, annars hoppar kortet mellan över och under medan besökaren scrollar. */
  var lastVW = document.documentElement.clientWidth;
  window.addEventListener('resize', function () {
    var vw = document.documentElement.clientWidth;
    if (vw === lastVW) return;
    lastVW = vw;
    place();
  });
  window.addEventListener('load', place);

  function init() {
    externalRefLinks(document);
    decorate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Direktlänk eller manuellt ändrad hash. Vid sidladdning öppnas listan direkt,
     men scrollen görs först när bilder och typsnitt har laddat klart, annars
     flyttar de sidan efteråt och raden hamnar utanför bild. Kortet öppnas inte. */
  function fromHash(instant) {
    if (HASH.test(window.location.hash)) showRef(window.location.hash.slice(1), instant === true);
  }
  window.addEventListener('hashchange', function () {
    close(false);
    fromHash(false);
  });
  if (HASH.test(window.location.hash)) {
    var early = document.getElementById(window.location.hash.slice(1));
    var earlyDet = early && early.closest('details[data-cpdp-refs]');
    if (earlyDet) earlyDet.open = true;
    if (document.readyState === 'complete') {
      fromHash(true);
    } else {
      window.addEventListener('load', function () { fromHash(true); });
    }
  }

  /* Temaredigeraren: en omladdad sektion får aldrig ligga kvar osynlig (den
     gemensamma infaden observerar bara element som fanns vid sidladdning),
     och en markerad referens ska synas i den öppnade listan. Kortets data läses
     om, och ett kort vars bubbla försvann stängs. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.cpdp-research .cpdp-reveal').forEach(function (el) { el.classList.add('is-in'); });
    externalRefLinks(root);
    dataCache = null;
    if (openBubble && !document.contains(openBubble)) close(false);
    decorate();
    place();
    fromHash(true);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    dataCache = null;
    if (openBubble && e.target && e.target.contains && e.target.contains(openBubble)) close(false);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var det = t.closest('details[data-cpdp-refs]');
    if (det) det.open = true;
  });
})();
